import React, { useCallback, useEffect, useMemo, useState } from "react";
import { CardBody, Col, Container, Row, Card, Button } from "reactstrap";
import { MaterialReactTable } from "material-react-table";
import { useDispatch, useSelector } from "react-redux";
import { MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LabelText } from "../Utils/Input";
import { customerIdData } from "../Customers/constants/constantFunctionsView";
import { useRef } from "react";
import { offerListForPolicy } from "./Constants/PolicyColumns";
import {
  addOfferDataUsingDispatch,
  handleDelete,
  mergedDataForOfferList,
} from "./Constants/ModifyPolicyDataFunctions";
import { mergeAndFilterOffers } from "./Constants/ModifyAddPartnerFunctions";
import { columnDataFormatForRatePlan } from "./Constants/ModifyDataFunctions";
export const OfferList = React.memo(
  ({ values, selectedOffers, offerDataArray, mergedArray, setMergedArray }) => {
    const dispatch = useDispatch();
    const isEdit = location.pathname.includes("update-policy");
    let grant = [];
    let charge = [];
    let usage = [];
    let grantsCount = [];
    let chargeCount = [];
    let usageCount = [];

    const policyId = customerIdData();
    const navigate = useNavigate();
    const handleDeleteRow = useCallback(
      (offerCode) => {
        setOfferDeleted(true);
        handleDelete(offerCode, dispatch);
      },
      [dispatch]
    );

    const column = useMemo(
      () =>
        offerListForPolicy(
          grant,
          charge,
          usage,
          grantsCount,
          chargeCount,
          usageCount,
          handleDeleteRow
        ),
      [grant, charge, usage, grantsCount, chargeCount, usageCount, handleDelete]
    );
    let orderData = [];
    orderData = useSelector((state) => state.SelectedOffer.offersselect);
    const settlementOffers = useSelector(
      (state) => state.SelectedOffer.settlementOffer
    );
    const [offerDeleted, setOfferDeleted] = useState(false);
    columnDataFormatForRatePlan(
      settlementOffers,
      grant,
      charge,
      usage,
      grantsCount,
      chargeCount,
      usageCount
    );

    useEffect(() => {
      if (!isEdit && !offerDeleted) {
        addOfferDataUsingDispatch(selectedOffers, settlementOffers, dispatch);
      }
      //future use
      // if(!mergedArray?.length){
      mergeAndFilterOffers(settlementOffers, setMergedArray);
      // }
    }, [
      isEdit,
      offerDeleted,
      selectedOffers,
      settlementOffers,
      dispatch,
      setMergedArray,
    ]);

    return (
      <div className="mb-3 mt-1 table-responsive">
        <div className="d-flex mt-3 mb-2">
          <h4 className="card-title mb-0 flex-grow-1">Offer List</h4>
          <Button
            color="secondary"
            className={
              "justify-content-end btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-md-auto ms-auto text-nowrap"
            }
            onClick={() => {
              if (!isEdit) {
                navigate("/offer-for-policy", { state: values });
              } else {
                navigate("/update-offer-for-policy", {
                  state: { selectedOffers, policyId },
                });
              }
            }}
          >
            <i className="ri-add-fill label-icon align-middle fs-16 me-2"></i>
            <span className="px-2 ps-3 ms-2 me-1 fw-bold">Add</span>
          </Button>
        </div>
        <div className="border">
          <MaterialReactTable
            displayColumnDefOptions={{
              "mrt-row-actions": {
                header: "",
                enableHiding: true,
                size: 52,
                grow: true,
              },
            }}
            defaultColumn={{
              minSize: 10,
              maxSize: 9001,
              muiTableBodyCellProps: {
                sx: {
                  fontFamily: "Inter,sans-serif",
                },
              },
              muiTableHeadCellProps: {
                sx: {
                  fontFamily: "Inter,sans-serif",
                },
              },
            }}
            enableTopToolbar={false}
            enableDensityToggle={false}
            enableBottomToolbar={true}
            enableColumnActions={true}
            columns={column}
            data={mergedArray}
          />
        </div>
      </div>
    );
  }
);
